<template>
    <component
        :is="link ? Link : 'div'"
        :href="link || undefined"
        class="block"
    >
        <UiCard
            v-if="deploy && deploy.id"
            class="flex items-center text-xs"
            :class="link ? 'transition hover:bg-neutral-50 dark:hover:bg-neutral-800' : ''"
        >
            <div class="grow-0 px-4 py-2 font-semibold">
                {{ deploy.id }}
            </div>
            <div class="flex-auto py-2">
                <div class="font-bold">
                    {{ title }}
                </div>
                <div class="text-neutral-500">
                    {{ dateTimeHumanReadableFromISO(deploy.created_at) }} ({{ relativeTime(deploy.created_at) }})
                    <span v-if="generating" class="italic">
                        · {{ lang('deployment::deployment.release.generating') }}
                    </span>
                    <span v-else-if="failed" class="italic text-amber-600">
                        · {{ lang('deployment::deployment.release.failed') }}
                    </span>
                </div>
            </div>
            <div class="grow-0 px-4"></div>
        </UiCard>
    </component>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue';
import { Link } from '@inertiajs/vue3';
import { Deploy } from '@src/Deployment/Pages/types';
import { dateTimeHumanReadableFromISO, relativeTime } from '@src/Common/Helpers/dates';

const props = defineProps<{
    deploy: Deploy;
}>();

const deploy = toRef(props, 'deploy');

const changelog = computed(() => deploy.value.release_changelog ?? null);

const link = computed(() =>
    changelog.value?.id ? route('deployment/changelog.admin.show', { id: changelog.value.id }) : null,
);

const title = computed(
    () => changelog.value?.title || deploy.value.changelog || deploy.value.commit_message,
);

const generating = computed(
    () => changelog.value != null && ['pending', 'generating'].includes(changelog.value.status),
);

const failed = computed(() => changelog.value?.status === 'failed');
</script>
